import { render, staticRenderFns } from "./small-ico.vue?vue&type=template&id=8c50d684&scoped=true"
import script from "./small-ico.vue?vue&type=script&lang=js"
export * from "./small-ico.vue?vue&type=script&lang=js"
import style0 from "./small-ico.vue?vue&type=style&index=0&id=8c50d684&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c50d684",
  null
  
)

export default component.exports